// Marker UI for barge-ins: "INTERRUPTED · HEARD n%" chip plus an expandable
// intended/unspoken breakdown. Used by the live voice bench and the call
// transcript drawer so both read the same way.

export interface InterruptionInfo {
  heardRatio: number;
  intendedText: string;
  /** Estimated text the user actually heard (the message body). */
  spokenText: string;
  interruptedAtMs?: number;
}

function unspokenTail(intended: string, spoken: string): string {
  const intendedWords = intended.split(/\s+/).filter(Boolean);
  const spokenCount = spoken.split(/\s+/).filter(Boolean).length;
  return intendedWords.slice(spokenCount).join(" ");
}

export function InterruptionChip({ info }: { info: InterruptionInfo }) {
  const heardPct = Math.round(Math.max(0, Math.min(1, info.heardRatio)) * 100);
  const unspoken = unspokenTail(info.intendedText, info.spokenText);
  const when = info.interruptedAtMs ? new Date(info.interruptedAtMs).toLocaleTimeString() : null;
  return (
    <div className="interrupt-block">
      <span className="interrupt-chip" title={when ? `interrupted at ${when}` : undefined}>
        INTERRUPTED · HEARD {heardPct}%
      </span>
      {(info.intendedText || unspoken) && (
        <details className="interrupt-detail">
          <summary>intended message</summary>
          {info.intendedText && (
            <div className="interrupt-line">
              <span className="interrupt-label">Intended:</span> <em>{info.intendedText}</em>
            </div>
          )}
          {unspoken && (
            <div className="interrupt-line interrupt-unspoken">
              <span className="interrupt-label">Unspoken:</span> <em>{unspoken}</em>
            </div>
          )}
        </details>
      )}
    </div>
  );
}
